import { filter } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, Platform, ToastController } from '@ionic/angular';
import { backendUrl } from 'src/environments/environment';
import { toPromise } from './toPromise';
import { BehaviorSubject } from 'rxjs';
import { LoginPagePage } from '../login-page/login-page.page';
// import * as products from '../../assets/products.json';
var products = require('../../assets/products.json');
export interface LogIn {
  username: string;
  password: number;
  phone_code: number;
  device_token: string;
}

export interface Location {
  country: string;
  province: string;
  town: string;
  street: string;
  house_no: string;
  building: string;
  pincode: string;
  id: number;
  area: string;
}

export interface UserInfo {
  created_at: string;
  deleted_at: string;
  email: string;
  email_verified_at: string;
  id: number;
  is_mobile_verified: number;
  meta_data: [];
  name: string;
  otp: string;
  phone: string;
  phone_code: string;
  seller: Seller;
  gender: String;
  dob: String;
  profile_photo: String;
  updated_at: string;
  username: string;
  is_default_shipping_address: Location;
  wallet_balance: number;
  language: string;
  token: string;
  meta_profile_photo: {
    value: String;
  };
}

export interface Seller {
  banner_photo: string;
  business_id: number;
  created_at: string;
  deleted_at: string;
  email: string;
  id: number;
  id_proof: string;
  is_account_verified: number;
  notification_limits: string;
  phone: string;
  phone_code: string;
  pickup_locations: Location;
  profile_photo: string;
  shop_body: string;
  shop_name: string;
  shop_title: string;
  shop_url: string;
  storage_locations: Location;
  updated_at: string;
  user_id: number;
  banners: Array<banner>;
  type: number;
  bank_account: string;
  bank_name: string;
  account_holder_name: string;
  account_status: number;
  change_account_request: {
    business_id: number;
    created_at: Date;
    deleted_at: Date;
    id: number;
    seller_id: number;
    status: number;
    updated_at: Date;
  };
  slug: string;
}

export interface banner {
  id?: number;
  name: string;
  type: number;
  category_id?: number;
  seller_id?: number;
  external_link?: string;
  img: string;
  product_id?: number;
  created_at?: Date;
  updated_at?: Date;
  deleted_at?: Date;
  linking_url: string;
}

export interface SignUp {
  otp: string;
  name: string;
  phone_code: string;
  phone: string;
  email: string;
  username: string;
  password: string;
  device_token: string;
  dob: Date;
}
export interface ImageUploadResponse {
  data: {
    ext: string;
    full_path: string;
    name: string;
  };
  status: Boolean;
}
export interface ChangePasswordObject {
  current_password: String;
  new_password: String;
  confirm_password: String;
}
export interface ChangeEmailObject {
  current_email: String;
  new_email: String;
}
export interface TokenVerifyResponse {
  status: boolean;
  data: UserInfo;
}
export interface FollowRequest {
  seller_id: Number;
}
export interface FollowResponse {
  status: boolean;
  data: Array<{
    created_at: Date;
    id: Number;
    seller_id: Number;
    updated_at: Date;
    user_id: Number;
    seller: Seller;
    hide: boolean;
  }>;
}
export interface LocationData {
  building: string;
  country: string;
  house_no: string;
  id: number;
  pincode: string;
  province: string;
  street: string;
  town: string;
  type?: string;
  longitude?: number;
  latitude?: number;
  area?: string;
}

export interface FaqResponse {
  status: boolean;
  data: Array<{
    category: string;
    items: Array<{
      answer: string;
      question: string;
    }>;
  }>;
}

export interface verificationResponse {
  id_proof: Array<{
    // img: string
  }>;
  description: string;
}

export interface SocailLogIn {
  social_token: string;
  device_token: string;
}

export interface SocailLogInVeriify {
  email: string;
  phone: number;
  phone_code: number;
  otp: string;
}

export interface SearchResponse {
  status: number;
  data: Array<[]>;
}

export interface TrendResponse {
  status: number;
  data: Array<[]>;
}

export interface ForgetPasswordObject {
  email: string;
}

export interface ForgetPasswordResponse {
  id: number;
  email: string;
  otp: string;
  created_at: Date;
  updated_at: Date;
  deleted_at: Date;
}

export interface ResetPasswordObject {
  id: number;
  otp?: String;
  password?: String;
  confirm_password?: String;
}

export interface SmartSearch {
  status?: number;
  data?: [
    {
      type: string;
      id: number;
      name: string;
      img: string;
      target_audience: number;
    }
  ];
}

export interface SmartSearchResponse {
  type: string;
  id: number;
  name: string;
  img: string;
  target_audience: number;
}

export interface versionResponse {
  status: number;
  data: {
    android_force_update: number;
    iphone_force_update: number;
    iphone_version: string;
    android_version: string;
  };
}
export enum SearchType {
  /* eslint-disable no-unused-vars */
  Category,
  Shop,
  Product,
  /* eslint-enable no-unused-vars */
}
@Injectable({
  providedIn: 'root',
})
export class AuthenticationStore {
  userInfo: UserInfo;
  token: String = localStorage.getItem('authToken') || null;
  isLogin = new BehaviorSubject(null);
  isLogout = new BehaviorSubject(null);
  clearAll = new BehaviorSubject(null);
  isClear = new BehaviorSubject(null);
  productsData = products;
  constructor(
    private httpClient: HttpClient,
    private toastController: ToastController,
    private router: Router,
    public platform: Platform,
    private modalCtrl: ModalController
  ) {}

  async login(params: LogIn): Promise<LogIn> {
    const url = `${backendUrl}login`;
    return toPromise(this.httpClient.post<LogIn>(url, params));
  }
  async signUp(params: SignUp): Promise<SignUp> {
    const url = `${backendUrl}register`;
    return toPromise(this.httpClient.post<SignUp>(url, params));
  }

  async tokenVerify(): Promise<TokenVerifyResponse> {
    const url = `${backendUrl}verifytoken`;
    const token = localStorage.getItem('authToken');
    const device_token = localStorage.getItem('device_token') || '';

    return toPromise(
      this.httpClient.post<TokenVerifyResponse>(
        url,
        { device_token: device_token },
        {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        }
      )
    );
  }

  async logOut(): Promise<void> {
    const url = `${backendUrl}logout`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<void>(url, null, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async imageUpload(
    base64: string,
    type: number = 0
  ): Promise<ImageUploadResponse> {
    const url = `${backendUrl}upload`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<ImageUploadResponse>(
        url,
        { file_name: base64, type: type },
        {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        }
      )
    );
  }
  async profileUpdate(profileUploadContent: Object): Promise<void> {
    const url = `${backendUrl}profile`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<void>(url, profileUploadContent, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }
  async changePassword(
    changePasswordObject: ChangePasswordObject
  ): Promise<void> {
    const url = `${backendUrl}changepassword`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<void>(url, changePasswordObject, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }
  async changeEmail(changeEmailObject: ChangeEmailObject): Promise<void> {
    const url = `${backendUrl}changeemail`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<void>(url, changeEmailObject, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async addLocation(
    customer: boolean = null,
    location: Location
  ): Promise<Location> {
    var url = '';
    if (customer) {
      url = `${backendUrl}location`;
    } else {
      url = `${backendUrl}seller/location`;
    }
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<Location>(url, location, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async getFollow(): Promise<FollowResponse> {
    const url = `${backendUrl}follow`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<FollowResponse>(url, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async postFollow(data: FollowRequest): Promise<void> {
    const url = `${backendUrl}follow`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<void>(url, data, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async requiredLogin() {
    if (this.userInfo) {
      return true;
    } else {
      const toast = await this.toastController.create({
        message: 'You need to login to perform this action',
        duration: 3000,
        position: 'top',
      });

      await toast.present();
      if (this.platform.is('mobile')) {
        this.router.navigate(['/login-page']);
      } else {
        // desktop login is a full page (was a modal)
        this.router.navigate(['/login-page'], {
          state: { returnUrl: this.router.url },
        });
      }
      return false;
    }
  }

  async updateLocation(
    customer: boolean = null,
    location: Location,
    locationId: number
  ): Promise<Location> {
    var url = '';
    if (customer) {
      url = `${backendUrl}location/${locationId}`;
    } else {
      url = `${backendUrl}seller/location/${locationId}`;
    }
    const token = localStorage.getItem('authToken');
    if (customer) {
      return toPromise(
        this.httpClient.patch<Location>(url, location, {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        })
      );
    } else {
      return toPromise(
        this.httpClient.put<Location>(url, location, {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        })
      );
    }
  }

  async getFaq(params = null): Promise<FaqResponse> {
    const url = `${backendUrl}faq`;
    return toPromise(
      this.httpClient.get<FaqResponse>(url, {
        params: params,
        headers: new HttpHeaders({}),
      })
    );
  }

  async addVerification(data: verificationResponse): Promise<void> {
    const url = `${backendUrl}seller/accountverification`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<void>(url, data, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async socialLogin(params: SocailLogIn): Promise<SocailLogIn> {
    const url = `${backendUrl}social-login`;
    return toPromise(this.httpClient.post<SocailLogIn>(url, params));
  }

  async signUpSocial(params: SocailLogInVeriify): Promise<SocailLogInVeriify> {
    const token = localStorage.getItem('authToken');
    const url = `${backendUrl}verify-social-login`;
    var header = {};
    if (token) {
      header = {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      };
    }
    return toPromise(
      this.httpClient.post<SocailLogInVeriify>(url, params, header)
    );
  }

  async changeLanguage(data): Promise<void> {
    const url = `${backendUrl}set-language`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<void>(url, data, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async getKeyWords(params = null): Promise<TrendResponse> {
    const url = `${backendUrl}search`;
    return toPromise(
      this.httpClient.get<TrendResponse>(url, {
        params: params,
        headers: new HttpHeaders({}),
      })
    );
  }

  async getRecentSearch(params = null): Promise<SearchResponse> {
    const url = `${backendUrl}recent-search`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.get<SearchResponse>(url, {
        params: params,
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async smartSearch(params = null): Promise<SmartSearch> {
    const url = `${backendUrl}smart-search`;
    return toPromise(
      this.httpClient.get<SmartSearch>(url, {
        params: params,
        headers: new HttpHeaders({}),
      })
    );
  }

  async forgetPassword(param: ForgetPasswordObject): Promise<void> {
    const url = `${backendUrl}password/email`;
    return toPromise(
      this.httpClient.post<void>(url, param, {
        headers: new HttpHeaders({}),
      })
    );
  }

  async resetPassword(
    changePasswordObject: ResetPasswordObject
  ): Promise<void> {
    const url = `${backendUrl}password/reset`;
    return toPromise(
      this.httpClient.post<void>(url, changePasswordObject, {
        headers: new HttpHeaders({}),
      })
    );
  }

  async deleteAcc(seller: number = 0): Promise<void> {
    const url =
      seller == 1
        ? `${backendUrl}seller/delete-account`
        : `${backendUrl}delete-account`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.delete<void>(url, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async removeImage(): Promise<void> {
    const url = `${backendUrl}profile-photo-remove`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<void>(
        url,
        {},
        {
          headers: new HttpHeaders({
            Authorization: `Bearer ${token}`,
          }),
        }
      )
    );
  }

  async videoUpload(param): Promise<ImageUploadResponse> {
    const url = `${backendUrl}upload-video`;
    const token = localStorage.getItem('authToken');
    return toPromise(
      this.httpClient.post<ImageUploadResponse>(url, param, {
        headers: new HttpHeaders({
          Authorization: `Bearer ${token}`,
        }),
      })
    );
  }

  async version(): Promise<versionResponse> {
    const url = `${backendUrl}version`;
    return toPromise(
      this.httpClient.get<versionResponse>(url, {
        headers: new HttpHeaders({}),
      })
    );
  }

  async getBase64(fileUrl: string): Promise<void> {
    const url = `${backendUrl}base64`;
    return toPromise(this.httpClient.post<void>(url, { name: fileUrl }, {}));
  }

  async getAllAddress(): Promise<void> {
    const url = `${backendUrl}address`;
    return toPromise(this.httpClient.get<void>(url, {}));
  }
  async updateAllAddress(id, paylaod): Promise<void> {
    const url = `${backendUrl}address/${id}`;
    return toPromise(this.httpClient.put<void>(url, paylaod));
  }
}
